import * as React from 'react';
import classnames from 'classnames';

import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import DiscoveryFiltersTitle from 'modules/discovery/components/filters/title/DiscoveryFiltersTitle';

import { __t, applyTranslations } from 'utils/language';

import './discovery-content-filters-gender.scss';

import type { DiscoveryContentFilters, DiscoveryFilterCheckbox } from 'types';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./discovery-content-filters-gender.i18n.json'));

type Props = {
  filters: DiscoveryContentFilters,
  handleFiltersUpdate: (a: any) => void
};

const msgKey = 'discovery_content_filters_gender';

class DiscoveryContentFiltersGender extends React.PureComponent<Props> {
  static defaultProps = {
    filters: {},
    handleFiltersUpdate: () => {}
  };

  getCheckboxClasses(type: 'vertical' | 'horizontal'): string {
    return classnames('discovery-content-filters-gender__section-checkboxes', {
      [`discovery-content-filters-gender__section-checkboxes--layout-${type}`]: Boolean(type)
    });
  }

  handleCheckboxChange = (event: SyntheticEvent<HTMLInputElement>): void => {
    const { filters } = this.props;
    const target = event.currentTarget;
    const name = target.name;
    const parent = target.dataset.parent || '';
    const identifier = target.dataset.identifier || '';
    const isChecked = target.checked;

    if (parent && identifier && name) {
      const arr = filters[parent];
      const selectedItem = arr.find(item => item.identifier === identifier);

      const updatedFilters = arr.map(item => {
        if (item.identifier === selectedItem.identifier) {
          return {
            ...selectedItem,
            value: String(isChecked),
            selected: isChecked
          };
        }

        return item;
      });

      this.handleUpdate({
        [parent]: updatedFilters
      });
    }
  };

  handleUpdate = (result: any): void => {
    const { handleFiltersUpdate } = this.props;

    if (handleFiltersUpdate) {
      handleFiltersUpdate(result);
    }
  };

  renderCheckbox(values: DiscoveryFilterCheckbox): React.ReactNode {
    return (
      <InputCheckbox
        key={`discovery-content-filters-gender__checkbox-${values.identifier}`}
        id={`discovery-content-filters-gender__checkbox-${values.identifier}`}
        name={String(values.name)}
        label={values.label}
        value={String(values.value)}
        checked={values.checked}
        data={{
          identifier: values.identifier,
          parent: values.parent
        }}
        onChange={this.handleCheckboxChange}
      />
    );
  }

  renderGenderCheckboxes(): React.ReactNode {
    const { filters } = this.props;
    const genders = filters.genders;

    return (
      <div className="discovery-content-filters-gender__section">
        <DiscoveryFiltersTitle
          title={__t(`${msgKey}.labels.gender`)}
        />
        <div className={this.getCheckboxClasses('horizontal')}>
          {
            (genders || []).map(gender => (
              <div
                key={`discovery-content-filters-gender__${gender.identifier}`}
                className="discovery-content-filters-gender__section-checkbox"
              >
                {
                  this.renderCheckbox({
                    identifier: gender.identifier,
                    name: gender.identifier,
                    label: gender.label,
                    value: gender.selected,
                    checked: gender.selected,
                    parent: 'genders'
                  })
                }
              </div>
            ))
          }
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="discovery-content-filters-gender">
        {this.renderGenderCheckboxes()}
      </div>
    );
  }
}

export default DiscoveryContentFiltersGender;
